export interface IconProps {
  width?: number;
  height?: number;
}

export default function AlignJustifyIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
    >
      <g>
        <path
          fill="currentColor"
          d="M.5 14a.5.5 0 01-.5-.5v-.75a.5.5 0 01.5-.5h14a.5.5 0 01.5.5v.75a.5.5 0 01-.5.5zm0-4.122a.5.5 0 01-.5-.5v-.75a.5.5 0 01.5-.5h14a.5.5 0 01.5.5v.751a.5.5 0 01-.5.5zM.5 6a.5.5 0 01-.5-.5v-.75a.5.5 0 01.5-.5h14a.5.5 0 01.5.5v.75a.5.5 0 01-.5.5zm0-4.25a.5.5 0 01-.5-.5V.5A.5.5 0 01.5 0h14a.5.5 0 01.5.5v.75a.5.5 0 01-.5.5z"
          data-name="Union 25"
          transform="rotate(180 7.5 7)"
        ></path>
      </g>
    </svg>
  );
}
